import * as XLSX from 'xlsx-js-style';


const getFileName = (name?: string) => {
  let timeSpan = new Date().toISOString();
  let sheetName = name || 'ExportResult';
  let fileName = `${sheetName}-${timeSpan}`;
  return {
    sheetName,
    fileName,
  };
};
export class TableUtil {

   // Style commun pour les en-têtes
  private static headerStyle = {
    font: { bold: true, color: { rgb: 'FFFFFF' } },
    fill: { fgColor: { rgb: '4472C4' } }, // bleu, change selon ton besoin
    alignment: { horizontal: 'center', vertical: 'center' },
  };

  private static styleHeaderRow(ws: XLSX.WorkSheet) {
    const range = XLSX.utils.decode_range(ws['!ref']!);
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
      const cell = ws[cellAddress];
      if (cell) {
        cell.v = String(cell.v).toUpperCase(); // majuscules
        cell.s = TableUtil.headerStyle;        // couleur
      }
    }
  }

  static exportTableToExcel(tableId: string, name?: string) {
    let { sheetName, fileName } = getFileName(name);

    let targetTableElm = document.getElementById(tableId);

    let wb = XLSX.utils.table_to_book(targetTableElm, <XLSX.Table2SheetOpts>{
      sheet: sheetName,
    });

    const ws = wb.Sheets[sheetName];
    this.styleHeaderRow(ws);

    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  static exportArrayToExcel(arr: any[], name?: string) {
    let { sheetName, fileName } = getFileName(name);

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.json_to_sheet(arr);

    this.styleHeaderRow(ws);

    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
  // static exportTableToExcel(tableId: string, name?: string) {
  //   let { sheetName, fileName } = getFileName(name);

  //   let targetTableElm = document.getElementById(tableId);

  //   let wb = XLSX.utils.table_to_book(targetTableElm, <XLSX.Table2SheetOpts>{
  //     sheet: sheetName,
  //   });

  //   XLSX.writeFile(wb, `${fileName}.xlsx`);
  // }

  // static exportArrayToExcel(arr: any[], name?: string) {
  //   let { sheetName, fileName } = getFileName(name);

  //   var wb = XLSX.utils.book_new();

  //   var ws = XLSX.utils.json_to_sheet(arr);

  //   XLSX.utils.book_append_sheet(wb, ws, sheetName);

  //   XLSX.writeFile(wb, `${fileName}.xlsx`);
  // }
}
